import { render } from "./Historical.vue?vue&type=template&id=7cf8d512&scoped=true"
import script from "./Historical.vue?vue&type=script&lang=js"
export * from "./Historical.vue?vue&type=script&lang=js"

import "./Historical.vue?vue&type=style&index=0&id=7cf8d512&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf8d512"]])

export default __exports__